module.exports = "<nav class=\"navbar-default navbar-static-side\" role=navigation> <section-owner-side-menu></section-owner-side-menu> </nav>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/1-owner/navigation.html
// module id = 626
// module chunks = 86